import { getGradedCardPrice } from "@/api/grading";
import { create } from "zustand";

interface GradedPricesStore {
  prices: Record<
    string,
    {
      result: { data: number | null } | null;
      promise: Promise<number | null> | null;
    }
  >;
  load(
    cardId: number,
    gradingCompanyId: string,
    gradeId: string,
  ): Promise<number | null>;
}

export const useGradedPricesStore = create<GradedPricesStore>((set, get) => ({
  prices: {},
  async load(cardId: number, gradingCompanyId: string, gradeId: string) {
    const key = `${cardId}-${gradingCompanyId}-${gradeId}`;

    const currentPrice = get().prices[key];

    if (currentPrice?.result) {
      return currentPrice.result.data;
    }

    if (currentPrice?.promise) {
      return currentPrice.promise;
    }

    const promise = getGradedCardPrice(cardId, gradingCompanyId, gradeId)
      .then((result) => {
        return result.data;
      })
      .catch((error) => {
        return null;
      });

    set((state) => ({
      prices: {
        ...state.prices,
        [key]: { result: null, promise },
      },
    }));

    const result = await promise;

    set((state) => ({
      prices: {
        ...state.prices,
        [key]: { result: { data: result }, promise: null },
      },
    }));

    return result;
  },
}));
